import { Box } from '@mui/material'
import { TSubscriptionDetails } from '../../../../../../core/types/CheckoutOrder'
import ListItemDefault from '../../../../../../components/ListItem/ListItemDefault'
import { maskCpfCnpjNumber } from '../../../../../../masks/masks'
import { formatarPhone } from '../../../../../../core/functions/phoneUtils'

export interface IOrderDetailCustomerProp {
  subscription?: TSubscriptionDetails
}

const SubscriptionOrderDetailCustomer = ({
  subscription,
}: IOrderDetailCustomerProp) => {
  return (
    <Box>
      <ListItemDefault title="Nome" value={subscription?.name} />
      <ListItemDefault title="E-mail" value={subscription?.email} />
      <ListItemDefault
        title="Celular"
        value={formatarPhone(
          subscription?.orderDetails?.customerPhone,
          subscription?.orderDetails?.customerPhoneCountryCode,
          subscription?.orderDetails?.customerCountryCode
        )}
      />
      <ListItemDefault
        title="CPF"
        value={maskCpfCnpjNumber(subscription?.orderDetails.customerDocument)}
      />
    </Box>
  )
}

export default SubscriptionOrderDetailCustomer
